export default __webpack_public_path__ + "static/media/mid-size-solution.88a179bc.png";